
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

const OTCPage = () => {
  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const categories = [
    {
      name: 'かぜ・のど・咳',
      icon: 'ri-thermometer-line',
      color: 'bg-red-100 text-red-800',
      image: 'https://public.readdy.ai/ai/img_res/74b964e98ff15ca3f174e21474504bbd.jpg'
    },
    {
      name: '胃腸・便秘',
      icon: 'ri-heart-pulse-line',
      color: 'bg-orange-100 text-orange-800',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20style%2C%20digestive%20health%20medicine%2C%20soft%20pastel%20colors%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20playful%20and%20friendly%20aesthetic&width=100&height=100&seq=otc-stomach&orientation=squarish'
    },
    {
      name: '疲労回復・アミノ酸',
      icon: 'ri-flashlight-line',
      color: 'bg-yellow-100 text-yellow-800',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20style%2C%20energy%20drink%20and%20vitamin%20supplements%2C%20soft%20pastel%20colors%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20playful%20and%20friendly%20aesthetic&width=100&height=100&seq=otc-energy&orientation=squarish'
    },
    {
      name: '皮膚・かゆみ・湿疹',
      icon: 'ri-hand-sanitizer-line',
      color: 'bg-pink-100 text-pink-800',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20style%2C%20skin%20care%20cream%20and%20ointment%2C%20soft%20pastel%20colors%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20playful%20and%20friendly%20aesthetic&width=100&height=100&seq=otc-skin&orientation=squarish'
    },
    {
      name: '目薬・花粉対策',
      icon: 'ri-eye-line',
      color: 'bg-blue-100 text-blue-800',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20style%2C%20eye%20drops%20and%20allergy%20medicine%2C%20soft%20pastel%20colors%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20playful%20and%20friendly%20aesthetic&width=100&height=100&seq=otc-eye&orientation=squarish'
    },
    {
      name: '漢方薬',
      icon: 'ri-leaf-line',
      color: 'bg-green-100 text-green-800',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20style%2C%20traditional%20herbal%20medicine%2C%20soft%20pastel%20colors%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20playful%20and%20friendly%20aesthetic&width=100&height=100&seq=otc-kampo&orientation=squarish'
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "name": "OTC販売 - 一心堂薬局",
    "description": "一心堂薬局のOTC医薬品販売。薬剤師による丁寧なアドバイスで、症状や体質に合った一般用医薬品をご提案します。",
    "url": `${import.meta.env.VITE_SITE_URL}/otc`,
    "mainEntity": {
      "@type": "MedicalBusiness",
      "name": "一心堂薬局 OTC販売",
      "description": "医師の処方がなくても購入できる一般用医薬品の販売と薬剤師相談"
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
      <SEOHead
        title="OTC販売 - お薬のことなんでもご相談ください | 一心堂薬局"
        description="一心堂薬局のOTC医薬品販売。薬剤師による丁寧なアドバイスで、症状や体質に合った一般用医薬品をご提案します。かぜ薬、胃腸薬、漢方薬など豊富に取り揃えています。千葉県香取郡多古町。"
        keywords="一般用医薬品,OTC,薬剤師相談,多古町,一心堂薬局,漢方,健康相談,千葉県香取郡,かぜ薬,胃腸薬,疲労回復"
        canonicalUrl={`${import.meta.env.VITE_SITE_URL}/otc`}
        ogTitle="OTC販売 - お薬のことなんでもご相談ください | 一心堂薬局"
        ogDescription="一心堂薬局のOTC医薬品販売。薬剤師による丁寧なアドバイスで、症状や体質に合った一般用医薬品をご提案します。"
        ogType="article"
        structuredData={structuredData}
      />

      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-md mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" onClick={handleHomeClick} className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
                <i className="ri-leaf-fill text-white text-sm"></i>
              </div>
              <span className="font-bold text-green-800" style={{fontFamily: 'Pacifico, serif'}}>
                相談できる薬局 一心堂薬局
              </span>
            </Link>
            <Link to="/" onClick={handleHomeClick} className="w-8 h-8 flex items-center justify-center">
              <i className="ri-close-line text-green-800 text-xl"></i>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="pt-20 pb-8 px-4">
        <div className="max-w-md mx-auto">
          <div className="mb-6">
            <img
              src="https://readdy.ai/api/search-image?query=Japanese%20pharmacist%20helping%20Japanese%20customer%20choose%20over-the-counter%20medicine%20at%20pharmacy%20counter%2C%20organized%20medicine%20shelves%20in%20background%2C%20warm%20lighting%20professional%20healthcare%20setting%2C%20clean%20white%20background%2C%20realistic%20photography%20style%2C%20welcoming%20atmosphere%2C%20Asian%20people%2C%20Japanese%20pharmacy&width=375&height=250&seq=otc-hero-jp&orientation=landscape"
              alt="OTC販売"
              className="w-full h-48 object-cover rounded-2xl shadow-lg"
            />
          </div>
          <h1 className="text-2xl font-bold text-amber-800 mb-3 text-center">
            お薬のこと、なんでもご相談ください
          </h1>
          <p className="text-lg text-amber-600 text-center mb-4">
            一心堂薬局のOTC販売
          </p>
        </div>
      </div>

      {/* Introduction */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <div className="bg-amber-50 rounded-2xl p-6 border-l-4 border-amber-600">
            <p className="text-gray-700 leading-relaxed mb-3">
              「病院に行くほどではないけれど、ちょっと気になる体の不調」
            </p>
            <p className="text-gray-700 leading-relaxed">
              そんなとき、気軽に立ち寄れる薬局でありたい。一心堂薬局は、地域の皆さまの身近な健康パートナーです。
            </p>
          </div>
        </div>
      </div>

      {/* What is OTC */}
      <div className="px-4 py-8 bg-amber-50">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            OTC医薬品とは
          </h2>
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <div className="flex items-start space-x-3 mb-4">
              <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-medicine-bottle-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold text-amber-800 mb-2">一般用医薬品</h3>
                <p className="text-sm text-gray-770 leading-relaxed">
                  OTC医薬品とは、医師の処方せんがなくても購入できる<span className="font-semibold">一般用医薬品</span>のことです。
                </p>
              </div>
            </div>
            <div className="bg-amber-50 rounded-xl p-4">
              <p className="text-sm text-gray-700 leading-relaxed">
                風邪薬、胃腸薬、漢方薬など、日常的な体調不良に対応できるお薬を豊富に取り揃えています。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Pharmacist Advice */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            薬剤師によるアドバイス
          </h2>
          <div className="bg-gradient-to-r from-amber-100 to-amber-50 rounded-2xl p-6">
            <div className="flex items-start space-x-4 mb-4">
              <div className="w-12 h-12 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-user-heart-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-amber-800 mb-2">自己判断せず、まずはご相談を</h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  症状や服用中のお薬を伺いながら、体質や生活習慣に合ったお薬をおすすめしています。
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-4">
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 mr-2 mt-0.5"></i>
                  <span>現在服用中のお薬との飲み合わせ確認</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 mr-2 mt-0.5"></i>
                  <span>アレルギーや副作用のチェック</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 mr-2 mt-0.5"></i>
                  <span>症状に合った最適なお薬のご提案</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-amber-600 mr-2 mt-0.5"></i>
                  <span>正しい使い方・飲み方の説明</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Categories */}
      <div className="px-4 py-8 bg-amber-50">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            取り扱いカテゴリー
          </h2>
          <div className="grid grid-cols-2 gap-4">
            {categories.map((category, index) => (
              <div key={index} className="bg-white rounded-2xl p-4 shadow-sm">
                <div className="w-16 h-16 bg-amber-50 rounded-xl flex items-center justify-center mx-auto mb-3 overflow-hidden">
                  <img 
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-center font-semibold text-gray-800 text-sm">
                  {category.name}
                </h3>
              </div>
            ))}
          </div>
          <div className="mt-6 bg-white rounded-2xl p-5 shadow-sm">
            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-leaf-line text-green-600 text-lg"></i>
              </div>
              <div>
                <h3 className="font-semibold text-green-800 mb-1">漢方薬も豊富に取り揃え</h3>
                <p className="text-sm text-gray-600">
                  体にやさしい自然由来の漢方薬も多数ご用意しています。体質改善や慢性的な症状にもご相談ください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Local Support */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            地域密着の安心感
          </h2>
          <div className="space-y-4">
            <div className="bg-amber-50 rounded-2xl p-5">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-chat-smile-2-line text-amber-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-1">健康相談もお気軽に</h3>
                  <p className="text-sm text-gray-600">
                    お薬のことだけでなく、健康相談・サプリメント・食生活などもお気軽にご相談ください
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-amber-50 rounded-2xl p-5">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-shopping-bag-line text-amber-600 text-lg"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-1">豊富な品揃え</h3>
                  <p className="text-sm text-gray-600">
                    日用品や衛生用品、健康食品なども取り扱っています
                  </p>
                </div>
              </div>
            </div>

            <div className="p-5 text-center">
              <a 
                href="tel:0479-70-6065"
                className="inline-flex items-center space-x-2 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-amber-700 transition-colors"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>電話</span>
              </a>
            </div>

          </div>
        </div>
      </div>

      {/* Closing Message */}
      <div className="px-4 py-8 bg-amber-50">
        <div className="max-w-md mx-auto">
          <div className="bg-white rounded-2xl p-6 shadow-sm text-center">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-amber-600 text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-amber-800 mb-3">
              皆さまの"かかりつけ薬局"として
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              一心堂薬局は、地域の皆さまの日々の健康をサポートいたします。<br />
              小さなことでもお気軽にご相談ください。
            </p>
            <div className="mt-6">
              <Link 
                to="/"
                onClick={handleHomeClick}
                className="inline-block bg-blue-600 text-white py-3 px-8 rounded-full font-medium text-sm"
              >
                <i className="ri-home-line mr-2"></i>
                ホームへ
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 z-50">
        <div className="max-w-md mx-auto">
          <div className="grid grid-cols-5 py-2">
            <Link to="/" onClick={handleHomeClick} className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-home-5-line text-lg"></i>
              <span className="text-xs mt-1">ホーム</span>
            </Link>
            <button className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-medicine-bottle-line text-lg"></i>
              <span className="text-xs mt-1">調剤</span>
            </button>
            <button className="flex flex-col items-center justify-center py-2 text-blue-600">
              <i className="ri-capsule-fill text-lg"></i>
              <span className="text-xs mt-1">OTC</span>
            </button>
            <button className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-map-pin-line text-lg"></i>
              <span className="text-xs mt-1">アクセス</span>
            </button>
            <a href="tel:0479-70-6065" className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-phone-line text-lg"></i>
              <span className="text-xs mt-1">お問合せ</span>
            </a>
          </div>
        </div>
      </nav>

      <div className="h-20"></div>
    </div>
  );
};

export default OTCPage;
